import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { IoMdContacts, IoMdPerson, IoLogoFacebook, IoLogoWhatsapp, IoMdMail, IoLogoInstagram, IoLogoYoutube, IoIosPaperPlane } from 'react-icons/io'

import { datosAdmin } from '../controllers/administrador';

const Conctatenos = () => {

  const anioAutor = new Date();

  return (
    <motion.div className='w-100 text-start shadow'
    style={{ background: 'linear-gradient(340deg,rgba(9, 67, 121, 1) 2%, rgba(0, 212, 255, 1) 100%)'}}
    initial={{opacity: 0}}
    whileInView={{opacity: 1}}
    transition={{duration: 1, delay: 0.3}}
    >
      <h4 className='p-2 mb-0 alert alert-info rounded-0' style={{fontFamily: 'Anton SC'}}>NUESTRO EQUIPO ESTÁ LISTO PARA ASISTIRTE CUANDO LO NECESITES.</h4>
      <hr className='my-0 text-light rounded-top' style={{ opacity: '0.5'}}/>
      <div className='d-flex flex-wrap justify-content-around'>
        <div className='m-3'>
          <p className='m-0 mb-1 text-center fw-bold' style={{maxWidth: '150px', lineHeight: 1.1, fontFamily: 'Fira Sans Extra Condensed'}}>¡Únete a nuestro grupo de Facebook!</p>
          <div className='m-auto' style={{maxWidth: '110px'}}>
            <img className='w-100 rounded-3' src={require('../img/qr-grupo-facebook.jpg')} alt="img logo swimming" style={{filter: "drop-shadow(-1px 1px 2px black)", cursor: 'pointer'}} onClick={() => window.open("https://www.facebook.com/share/g/17WXRoyTXn/", "_blank")}/>
          </div>
        </div>
        <div className='m-3'>
          <div>
            <h5 className='mb-1 text-center text-light' style={{fontFamily: 'Anton SC', letterSpacing: '1.5px', textShadow: '0 0 3px black'}}>{datosAdmin.nombre}</h5>
            <hr className='my-1 text-light rounded-bottom' style={{ opacity: '0.5'}}/>
          </div>
          <div className='d-flex flex-column' style={{fontFamily: 'Lora', fontSize: '15px'}}>
            <p className='m-0' style={{lineHeight: 1.1}}><b>Organizador/a.</b> {datosAdmin.encargado}.</p>
            <Link to={`mailto:${datosAdmin.email}`} target='_blank' style={{textDecoration: 'none'}} className='text-dark fw-bold'>{datosAdmin.email}</Link>
            <Link to={`https://wa.me/57${datosAdmin.celCorto}`} target='_blank' style={{textDecoration: 'none'}} className='text-dark fw-bold'><b>+57</b> {datosAdmin.cel}</Link>
          </div>
          <hr className='my-1 text-light rounded-top' style={{ opacity: '0.5'}}/>
          <p className='mb-0 text-center fw-bold' style={{fontFamily: 'Lora', fontSize: '13px', color: 'rgba(212, 212, 212, 1)', textShadow: '0 0 3px black'}}>© 2023 - {anioAutor.getFullYear()} PROWEBSPORTS</p>
          <div className='d-flex justify-content-center align-items-center'>
            <Link to="mailto:pws@prowebsports.com.co" target='_blank' style={{textDecoration: 'none'}}><IoMdMail className='fs-3' style={{color: '#ffffffff'}}/></Link>
            <Link to="https://wa.me/573245884041" target='_blank' style={{textDecoration: 'none'}}><IoLogoWhatsapp className='fs-3' style={{color: '#ffffffff'}}/></Link>
            <Link to="https://www.facebook.com/emanuel.barbosa.908132" target='_blank' style={{textDecoration: 'none'}}><IoLogoFacebook className='fs-3' style={{color: '#ffffffff'}}/></Link>
            <Link to="https://www.instagram.com/prowebsports/" target='_blank' style={{textDecoration: 'none'}}><IoLogoInstagram className='fs-3' style={{color: '#ffffffff'}}/></Link>
          </div>
        </div>
        <div className='m-3'>
          <h6 className='m-0 text-light' style={{fontFamily: 'Anton SC', letterSpacing: '1.2px', textShadow: '0 0 3px black'}}>EQUIPO <span className='text-warning'>P</span>RO<span className='text-info'>W</span>EB<span className='text-danger'>S</span>PORTS</h6>
          <div className='d-flex flex-column' style={{fontFamily: 'Lora', fontSize: '15px'}}>
            <hr className='my-1 text-light rounded-top' style={{ opacity: '0.5'}}/>
            <p className='m-0' style={{lineHeight: 1.1}}><b>Ing.</b> Emanuel Barbosa L.</p>
            <Link to="https://wa.me/573245884041" target='_blank' style={{textDecoration: 'none'}} className='text-dark fw-bold'><b>+57</b> 324-588-4041</Link>
            <hr className='my-1 text-light rounded-top' style={{ opacity: '0.5'}}/>
            <p className='m-0' style={{lineHeight: 1.1}}><b>Ing.</b> Ywrani Barbosa L.</p>
            <Link to="https://wa.me/573209147444" target='_blank' style={{textDecoration: 'none'}} className='text-dark fw-bold'><b>+57</b> 320-914-7444</Link>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default Conctatenos;